/** Row shaping for the Drivstofftype matrix (#586 AC5). */

export interface DrivstoffSerieRow {
  drivstoff: string
  count: number
  share_pct: number
}

export interface DrivstoffSerie {
  merke: string
  rows: DrivstoffSerieRow[]
  total: number
}

/**
 * Fuels in the "Alle" order, with any brand-only fuel appended after it.
 *
 * Row order has to come from one series, or each column would sort itself and
 * the matrix would stop lining up. "Alle" is the natural choice: it contains
 * every fuel in the segment. A brand-only fuel can still exist when a filter
 * narrows "Alle" — those go after the shared order, sorted so the tail is
 * deterministic between two identical requests.
 */
export function fuelOrder(series: DrivstoffSerie[]): string[] {
  const order = series[0]?.rows.map(r => r.drivstoff) ?? []
  const seen = new Set(order)
  const extra: string[] = []
  for (const s of series.slice(1)) {
    for (const r of s.rows) {
      if (!seen.has(r.drivstoff)) {
        seen.add(r.drivstoff)
        extra.push(r.drivstoff)
      }
    }
  }
  return [...order, ...extra.sort((a, b) => a.localeCompare(b, 'nb-NO'))]
}
